import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/account/lieu-de-travail')({
  component: () => <Outlet />,
});
